import { FormControl, FormControlLabel, RadioGroup, Stack, TextField } from "@mui/material";
import Radio from "@mui/material/Radio";
import { useAtom } from "jotai";
import React, { useState } from "react";
import { AnswerAtom } from "../atoms";


export const MultiChoiceQuestion = () => {
  const [answer, setAnswer] = useAtom(AnswerAtom);

  const onTextChange = (index, text) => {
    console.log("onTextChange", index, text)
    setAnswer(prev => {
      const options = [...(prev?.options || [])];
      if (options?.length >= index) {
        options[index].option = text;
        options[index].checked = text?.length > 0;
      }
      return {
        ...prev,
        options: [...options]
      }
    });
  };

  const onSelect = (index, checked) => {
    console.log(index, checked)
    console.log("index, checked")
    setAnswer(prev => ({
      ...prev,
      text: checked ? prev?.options[index]?.option : "",
      options: prev?.options?.map((i, ind) => ({
        ...i,
        checked: ind === index ? checked : false,
        option: i?.other && ind !== index ? "" : i?.option,
      }))
    }));
  };

  return (
    <>
      <FormControl>
        <RadioGroup>
          {answer?.options?.map((item, index) => {
            if (item?.other) {
              return (
                <FormControlLabel
                  key="other"
                  value="other"
                  control={
                    <Stack direction="row" spacing={2} alignItems="flex-start">
                      <Radio
                        checked={item?.checked}
                        // disabled={!item?.option}
                        onChange={(e, checked) => {
                          onSelect(index, checked)
                          if (checked) {
                            const textfield = document.getElementById(`${index}_other`);
                            if (textfield) {
                              textfield?.focus();
                            }
                          }
                        }}
                      />
                      <TextField
                        size="small" id={`${index}_other`}
                        value={item?.option}
                        placeholder="Other"
                        onChange={(e) => onTextChange(index, e?.target?.value)}
                        onBlur={e => {
                          setAnswer(prev => {
                            let options = [...(prev?.options || [])];
                            if (options?.length >= index) {
                              if (options[index]?.checked) {
                                options = options?.map((i, idx) => idx !== index && i?.checked ? {...i, checked: false} : {...i})
                              }
                            }
                            return {
                              ...prev,
                              text: options[index].checked ? (options[index].option || "Other") : "",
                              options: [...options]
                            }
                          });
                        }}
                        // disabled={!item?.checked}
                      />
                    </Stack>
                  }
                  label=""
                />
              );
            }

            return (
              <FormControlLabel
                value={item?.option}
                control={<Radio checked={item?.checked} />}
                checked={item?.checked}
                label={item?.option}
                key={item.option}
                sx={{ pb: 0.7 }}
                onChange={(e, checked) => onSelect(index, checked)}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </>
  );
};